define('rebrush/components/checkout/reepay/checkout',[
    'lodash',
    'jquery',
    'cartware/components/_base',
    'cartware/components/Registry',
    'cartware/jquery/bem',
    'gigaset/spinner'
], function(
    _,
    $,
    Component,
    Registry,
    BEM,
    Spinner
) {
    return Component.create({
        blockIdentifier: 'reepay-payment',
        config: gigaset.checkout,
        reepayContainerId: 'rp_container',
        reepay: null,

        $init: function() {
            this.mode = this.config.mode ? Number(this.config.mode) : null;
            this.modeMapping = this.config.mode_mapping || null;
            this.block = BEM.block('reepay-payment') || null;

            if (!this.block || !this.mode) {
                return;
            }

            this.paymentSessionId = this.block.data('session-id') ? window.atob(this.block.data('session-id')) : null;

            if (typeof this.paymentSessionId === 'undefined' || !this.paymentSessionId) {
                return;
            }

            this.initRepayObject();

            if (!this.reepay) {
                return;
            }

            this.addEventHandlers();
        },

        addEventHandlers: function() {
            switch (this.mode) {
                case 1: // embedded
                    this.reepay.addEventHandler(Reepay.Event.Accept, (data) => this.acceptHandler(data));
                    this.reepay.addEventHandler(Reepay.Event.Error, (data) => this.errorHandler(data));
                    this.reepay.addEventHandler(Reepay.Event.Cancel, (data) => this.cancelHandler(data));
                    this.reepay.addEventHandler(Reepay.Event.Close, (data) => this.closeHandler(data));

                    var cta = $('.' + BEM.buildElementClassname(this.blockIdentifier, 'cta', 'cancel'));
                    cta.on('click', _.bind(this.cancelBtnHandler , this));

                    break;
                case 2: // modal
                    this.reepay.addEventHandler(Reepay.Event.Accept, (data) => this.acceptHandler(data));
                    this.reepay.addEventHandler(Reepay.Event.Error, (data) => this.errorHandler(data));
                    this.reepay.addEventHandler(Reepay.Event.Cancel, (data) => this.cancelHandler(data));
                    this.reepay.addEventHandler(Reepay.Event.Close, (data) => this.closeHandler(data));

                    var cta = $('.' + BEM.buildElementClassname(this.blockIdentifier, 'cta', 'submit'));
                    cta.on('click', _.bind(this.submitBtnHandler , this));

                    break;
                case 3: // window
                    break;
                default:
                    break;
            }
        },

        errorHandler: function (data) {
            var url = this.config.url.error || '';

            if (!url) {
                return;
            }

            this._sendAjaxRequest(url, data, null, (response) => {
                if (response && response.redirect_url) {
                    window.location = response.redirect_url;
                }
            });
        },

        acceptHandler: function (data) {
            var url = this.config.url.accept || '';

            if (!url) {
                return;
            }

            if((data.error === undefined || !data.error || data.error === "error.session.INVOICE_ALREADY_PAID" || data.error === "invoice_already_settled" ) && data.invoice) {
                this._sendAjaxRequest(url, data, null, (response) => {
                    if (response && response.redirect_url) {
                        window.location = response.redirect_url;
                    }
                });
            }
        },

        cancelHandler: function (data) {
            var url = this.config.url.cancel || '';

            if (!url) {
                return;
            }

            this._sendAjaxRequest(url, data, null, (response) => {
                if (response && response.redirect_url) {
                    window.location = response.redirect_url;
                }
            });
        },

        closeHandler: function (data) {
            // not in use yet
            var url = this.config.url.close || '';
        },

        submitBtnHandler: function () {
            this.reepay.show(self.paymentSessionId);
        },

        cancelBtnHandler: function(e) {
            const cta = $(e.currentTarget);
            const orderId = this.block.data('order-id') ? window.atob(this.block.data('order-id')) : null;

            this.cancelHandler({
                id: this.paymentSessionId,
                invoice: orderId
            });
        },

        initRepayObject: function() {
            switch (this.mode) {
                case 1: // embedded
                    this.reepay = new Reepay.EmbeddedCheckout(this.paymentSessionId , this.reepayContainerId);
                    break;
                case 2: // modal
                    this.reepay = new Reepay.ModalCheckout(this.paymentSessionId);
                    break;
                case 3: // window
                    this.reepay = new Reepay.WindowCheckout(this.paymentSessionId);
                    break;
                default:
                    this.reepay = null;
                    break;
            }
        },

        /**
         * Send ajax request
         *
         * @param url
         * @param data
         * @param callback
         * @param onSuccessCallback
         * @private
         */
        _sendAjaxRequest: function (url, data, callback, onSuccessCallback) {
            Spinner.add();
            data = data || {};

            data._isAjax = 1;

            // add isAjax param to avoid caching problems
            if (url.indexOf('isAjax=1') === -1 && typeof data === 'string' && data.indexOf('isAjax=1') === -1) {
                url += url.indexOf('?') === -1 ? '?isAjax=1' : '&isAjax=1';
            }

            url = (this.isSecure === true && url.indexOf('http://') === 0) ? url.replace('http://', 'https://') : url;

            $.ajax(url, {
                method: 'POST',
                data: data
            }).then(_.bind(function (response, status, xhr) {
                Spinner.remove();

                // reponse callback
                if (typeof callback === 'function') {
                    callback(response, status, xhr);
                }

                // got error
                if (!response || status !== 'success') {
                    console.log('Ajax: error');
                    return;
                }

                // response callback on success
                if (typeof onSuccessCallback === 'function') {
                    onSuccessCallback(response, status, xhr);
                }
            }, this));
        },
    });

});

